import { MOBILE_SCREEN_WIDTH } from '@config/screen'
import { useEffect } from 'react'
import { useAction, useAppSelector } from '@shared/lib/redux'

import { appStore } from './app.slice'

export const useMobile = () => {
  const isMobile = useAppSelector(appStore.selectors.selectIsMobile)
  const setMobileMode = useAction(appStore.actions.setIsMobile)
  return {
    setMobileMode,
    isMobile
  }
}

export const useObserveMobileMode = () => {
  const { setMobileMode } = useMobile()

  useEffect(() => {
    let timeoutId: ReturnType<typeof setTimeout> | null = null

    const handleResize = (): void => {
      if (!timeoutId) {
        setMobileMode(window.innerWidth <= MOBILE_SCREEN_WIDTH)

        // Устанавливаем таймаут для throttling
        timeoutId = setTimeout(() => {
          timeoutId = null
        }, 200)
      }
    }

    handleResize() // Проверить размер окна при первоначальной загрузке
    window.addEventListener('resize', handleResize) // Обработчик изменения размера окна

    return () => {
      window.removeEventListener('resize', handleResize) // Очистить обработчик при размонтировании
      if (timeoutId) {
        clearTimeout(timeoutId) // Очистить таймаут, если он еще не завершился
      }
    }
  }, [setMobileMode])
}
